import { render } from "./Header.vue?vue&type=template&id=e7ad73c8&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=e7ad73c8&scoped=true&lang=scss"

import exportComponent from "/Users/Matt/projects/betherance/betherswap/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7ad73c8"]])

export default __exports__